// Fashion tills ask getProducts1 for the variant fields (parentProductId,
// isVariant). A services build without them rejects the whole query, which would
// leave the till with no products at all. On that error the page is fetched again
// without the variant fields, and they are not asked for again until reload — the
// layout then shows plain styles and its "Run a Full Sync" notice.
const VARIANT_FIELDS = /parentProductId|isVariant/;
let variantsUnsupported = false;

const mentionsVariantField = (errors) => Array.isArray(errors) && errors.some((e) => VARIANT_FIELDS.test(String(e?.message || "")));

// fetchPage(query) performs the request; buildQuery(includeVariants) builds it.
export async function fetchProductsPage(fetchPage, buildQuery, wantVariants) {
  const include = Boolean(wantVariants) && !variantsUnsupported;
  const fallBack = () => {
    variantsUnsupported = true;
    return fetchPage(buildQuery(false));
  };
  let response;
  try {
    response = await fetchPage(buildQuery(include));
  } catch (err) {
    if (include && mentionsVariantField(err?.response?.data?.errors)) return fallBack();
    throw err;
  }
  if (include && mentionsVariantField(response?.data?.errors)) return fallBack();
  // Fetchers that swallow errors (productServices.getProducts) return nothing, so
  // the cause is unknown: try once without the variant fields, and only stop
  // asking for them if that attempt works.
  if (include && !response?.data?.data) {
    const plain = await fetchPage(buildQuery(false));
    if (plain?.data?.data) variantsUnsupported = true;
    return plain;
  }
  return response;
}

export const variantFieldsUnsupported = () => variantsUnsupported;

// For tests.
export const resetVariantSupport = () => {
  variantsUnsupported = false;
};
